module.exports = __webpack_public_path__ + "img/L1.7ed86549.svg";